import React from "react";

// Size presets driving both the icon mark and the wordmark type scale.
const SIZE_MAP = {
  sm: { icon: 20, text: "text-sm" },
  md: { icon: 28, text: "text-lg" },
  lg: { icon: 40, text: "text-2xl" },
};

/**
 * Inline brand mark — a rounded-square badge with an open white stroke.
 * Mirrors public/favicon.svg (and the brand kit's 01-logo.png) so the app,
 * the browser tab, link previews and the Google Business Profile all show
 * the same red-orange mark (brand refresh 2026-10-01).
 */
export function LogoMark({ size = 28, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="ResumePilot360"
      className={className}
    >
      <rect x="0" y="0" width="64" height="64" rx="14" fill="#CB4029" />
      {/* compass ring + cardinal ticks */}
      <circle cx="32" cy="32" r="14" fill="none" stroke="#FFFFFF" strokeWidth="2.25" opacity="0.85" />
      <g stroke="#FFFFFF" strokeWidth="2.25" strokeLinecap="round" opacity="0.85">
        <line x1="32" y1="14.5" x2="32" y2="18.5" />
        <line x1="49.5" y1="32" x2="45.5" y2="32" />
        <line x1="32" y1="49.5" x2="32" y2="45.5" />
        <line x1="14.5" y1="32" x2="18.5" y2="32" />
      </g>
      {/* paper-airplane needle */}
      <polygon points="32,16 41,33 32,29 23,33" fill="#FFFFFF" />
      <polygon points="32,16 32,29 41,33" fill="#FFFFFF" opacity="0.55" />
    </svg>
  );
}

/**
 * ResumePilot360 wordmark + icon lockup.
 *
 * @param {"sm"|"md"|"lg"} size - controls icon and font size, default "md"
 * @param {boolean} showWordmark - when false, renders icon-only (e.g. a
 *   collapsed sidebar), default true
 * @param {string} className - extra classes for the outer wrapper
 */
export default function Logo({ size = "md", showWordmark = true, isLight = true, className = "" }) {
  const { icon, text } = SIZE_MAP[size] || SIZE_MAP.md;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoMark size={icon} />
      {showWordmark && (
        <span className={`font-['Manrope'] ${text} font-extrabold tracking-tight ${isLight ? "text-slate-900" : "text-white"}`}>
          Resume<span className={isLight ? "text-[#A67C52]" : "text-[#C9A27A]"}>Pilot360</span>
        </span>
      )}
    </div>
  );
}

export { Logo };
